
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { vscDarkPlus } from "react-syntax-highlighter/dist/esm/styles/prism";
import { xcode } from "react-syntax-highlighter/dist/esm/styles/hljs";
import { MdOutlineCopyAll, MdCheck } from "react-icons/md";
import { useLanguage } from "../Translations/LenguageContext";

const InfoInstallationModal = ({ show, handleClose, site_id }) => {
    const { t } = useLanguage();
    const [copied, setCopied] = useState(false);
    const [activeTab, setActiveTab] = useState("standard");

    const theme =
        document.documentElement.getAttribute("data-theme") || "light";

    const syntaxTheme = theme === "dark" ? vscDarkPlus : xcode;

    const closeModal = () => handleClose();

    const tag = `<script
    src="https://property.abstracht.com/propV1.js"
    data-site-id="${site_id}">
</script>`;

    const copyTag = async () => {
        try {
            await navigator.clipboard.writeText(tag);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (error) {
            console.error("Failed to copy installation tag:", error);
        }
    };

    return (
        <Modal
            show={show}
            centered
            onHide={closeModal}
            scrollable
        >
            <div className="modal_header">
                <p className="modal_header_title">{t.properties.how_to_title}</p>
            </div>

            <p className="modal_header_title_description">
                {t.properties.how_to_desc}
            </p>

            <div className="modal_main_cont">
                <div className="installation_info_cont">
                    <div className="installation_info_cont_inner">
                        <p className="parag_title">
                            {t.properties.how_to_step_copy_title}
                        </p>

                        <p className="parag_content">
                            {t.properties.how_to_step_copy_desc}
                        </p>

                        <div className="tag_cont_modal">
                            <button
                                type="button"
                                className="tag_header_btn"
                                onClick={copyTag}
                            >
                                {copied ? <MdCheck /> : <MdOutlineCopyAll />}
                            </button>

                            <SyntaxHighlighter
                                language="html"
                                style={syntaxTheme}
                                customStyle={{
                                    background: "transparent",
                                    fontSize: "12px",
                                    fontFamily: "Consolas, Monaco, monospace",
                                    margin: 0,
                                }}
                            >
                                {tag}
                            </SyntaxHighlighter>
                        </div>

                        <p className="parag_title">
                            {t.properties.how_to_step_type_title}
                        </p>

                        <div className="installation_tabs">
                            <button
                                type="button"
                                className={
                                    activeTab === "standard" ? "active" : ""
                                }
                                onClick={() => setActiveTab("standard")}
                            >
                                {t.properties.how_to_tab_standard}
                            </button>

                            <button
                                type="button"
                                className={
                                    activeTab === "spa" ? "active" : ""
                                }
                                onClick={() => setActiveTab("spa")}
                            >
                                {t.properties.how_to_tab_spa}
                            </button>

                            <button
                                type="button"
                                className={
                                    activeTab === "tagmanager" ? "active" : ""
                                }
                                onClick={() => setActiveTab("tagmanager")}
                            >
                                {t.properties.how_to_tab_tagmanager}
                            </button>
                        </div>

                        {activeTab === "standard" && (
                            <div className="installation_instructions">
                                <p className="parag_subtitle">
                                    {t.properties.how_to_standard_subtitle}
                                </p>

                                <ol className="installation_steps">
                                    <li>{t.properties.how_to_standard_step_1}</li>
                                    <li>
                                        {t.properties.how_to_standard_step_2}{" "}
                                        <code>&lt;/head&gt;</code> tag.
                                    </li>
                                    <li>
                                        {t.properties.how_to_standard_step_3}{" "}
                                        <code>&lt;/head&gt;</code>.
                                    </li>
                                    <li>{t.properties.how_to_standard_step_4}</li>
                                </ol>

                                <p className="parag_content">
                                    {t.properties.how_to_standard_desc}
                                </p>
                            </div>
                        )}

                        {activeTab === "spa" && (
                            <div className="installation_instructions">
                                <p className="parag_subtitle">
                                    {t.properties.how_to_spa_subtitle}
                                </p>

                                <p className="parag_content">
                                    {t.properties.how_to_spa_desc}
                                </p>

                                <ol className="installation_steps">
                                    <li>{t.properties.how_to_spa_step_1}</li>
                                    <li>
                                        {t.properties.how_to_spa_step_2}{" "}
                                        <code>&lt;head&gt;</code> tag.
                                    </li>
                                    <li>{t.properties.how_to_spa_step_3}</li>
                                    <li>{t.properties.how_to_spa_step_4}</li>
                                </ol>

                                <p className="parag_content">
                                    {t.properties.how_to_spa_desc_2}
                                </p>
                            </div>
                        )}

                        {activeTab === "tagmanager" && (
                            <div className="installation_instructions">
                                <p className="parag_subtitle">
                                    {t.properties.how_to_tagmanager_subtitle}
                                </p>

                                <ol className="installation_steps">
                                    <li>{t.properties.how_to_tagmanager_step_1}</li>
                                    <li>{t.properties.how_to_tagmanager_step_2}</li>
                                    <li>{t.properties.how_to_tagmanager_step_3}</li>
                                    <li>{t.properties.how_to_tagmanager_step_4}</li>
                                    <li>{t.properties.how_to_tagmanager_step_5}</li>
                                </ol>

                                <p className="parag_content">
                                    {t.properties.how_to_tagmanager_desc}
                                </p>
                            </div>
                        )}

                        <p className="parag_title">
                            {t.properties.how_to_step_publish_title}
                        </p>

                        <p className="parag_content">
                            {t.properties.how_to_step_publish_desc}
                        </p>

                        <p className="parag_content">
                            {t.properties.how_to_support}{" "}
                            <a href="mailto:support@abstracht.com">
                                support@abstracht.com
                            </a>.
                        </p>
                    </div>
                </div>
            </div>

            <div className="modal_footer">
                <div className="modal_footer_err_cont" />

                <div className="modal_footer_btn_cont">
                    <button
                        className="modale_close_btn"
                        onClick={closeModal}
                    >
                        {t.close}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default InfoInstallationModal;
